module.exports = __webpack_public_path__ + "img/IMG_20191125_200423.d925f4b0.jpg";